import { useEffect } from 'react';

/**
 * @param {HTMLElement} ref
 * @param {() => void} handler
 */
export function useOnClickOutside(ref = null, handler = null) {
  useEffect(() => {
    const listener = (e) => {
      if (!ref || ref.contains(e.target)) return;
      handler?.();
    };
    document.body.addEventListener('click', listener);
    return () => document.body.removeEventListener('click', listener);
  }, [ref, handler]);
}
